import { Input, Modal } from 'rsuite';
import { Label } from "../Label";
import { CustomButton } from "../CustomButton";

const ModalReasonCancel = ({ open, onClose, reason, setReason, alterarStatus }) => {

  return(
    <Modal
      backdrop="static"
      open={open}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100%',
      }}
    >
        <Modal.Header>
          <Modal.Title>Cancelamento do pedido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Label htmlFor="motivoCancelamento">
              Motivo do cancelamento
          </Label>
          <Input
            type="text"
            value={reason} 
            onChange={setReason}
            placeholder="Informe o motivo"
            style={{ width: 400 }}
          />
        </Modal.Body>
        <Modal.Footer>
          <CustomButton onClick={()=> alterarStatus()} color="red" appearance="primary">
            Ok
          </CustomButton>
          <CustomButton onClick={onClose} appearance="subtle">
            Fechar
          </CustomButton>
        </Modal.Footer>
  </Modal>
  )
}
export default ModalReasonCancel;